import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Typography, useMediaQuery, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import useRTL from 'src/hooks/useRTL';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad';
import { theme } from '../../Template3/Template';
import { useCompanyData } from '../contexts/DataContext';
import { useNavigate } from 'react-router-dom';
import NoImage from 'src/assets/images/no-pictures.png'
import { SectionTitle as T1SectionTitle } from '../../Template1/components/SectionTitle';
import { SectionTitle as T2SectionTitle } from '../../Template2/components/SectionTitle';
import { SectionTitle as T3SectionTitle } from '../../Template3/components/SectionTitle';
import { SectionTitle as T4SectionTitle } from '../../Template4/components/SectionTitle';
import { textVariant, textClasses } from '../../shared/config';
import SectionLayout from '../../shared/layout/SectionLayout';
import '../../shared/styles.css'

const useStyles = makeStyles((theme) => ({
    cardShadow:props => ({
        boxShadow: props.shadow ? props?.shadow : props.defaultShadow ? props.defaultShadow : 'none',
        "-webkit-box-shadow": props.shadow ? props?.shadow : props.defaultShadow ? props.defaultShadow : 'none',
        "-moz-box-shadow": props.shadow ? props?.shadow : props.defaultShadow ? props.defaultShadow : 'none'
    }),

    card5BtnCl:{
        background: 'rgb(2,0,36)',
        background: '-moz-linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 0%, rgba(0,212,255,1) 100%)',
        background: '-webkit-linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 0%, rgba(0,212,255,1) 100%)',
        background: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 0%, rgba(0,212,255,1) 100%)',
    },

    cardListDiv:{
        display:'flex',
        alignItems:"flex-start",
        flexDirection:'row',
        width:"100%",
        margin:"auto",
        [theme.breakpoints.down('md')]: {
            flexDirection:'column',
            justifyContent:'center !important'
        }
    }
}));

const TitleList = {
    '1': T1SectionTitle,
    '2': T2SectionTitle,
    '3': T3SectionTitle,
    '4': T4SectionTitle,
};
const fontFamilyList = {
    '1': "'Nunito Sans', sans-serif",
    '2': "'Roboto', sans-serif",
    '3': "'Poppins', sans-serif",
    '4': "'Nunito Sans', sans-serif",
};

const Features = (props) => {
    const { data } = useCompanyData();
    const { companyDomain, isRTL, companyData, themeDesign, chatgptContent } = data;
    const { pathname:url } = useLocation();
    const { contentData, index } = props;
    const classes = useStyles();

    const mobileView = useMediaQuery(theme.breakpoints.down('md'));
    const { buttonColor, buttonFontColor, buttonFontSize, autoButtonSize, buttonWidth, buttonHeight, sectionBackgroundColor, sectionPaddingTop, sectionPaddingBottom, sectionPaddingLeft, sectionPaddingRight,
        itemShadow, imgRadiusGeneral,buttonRadiusGeneral,
        // sectionFontColor,
        generalTitleFontSize, generalSubTitleFontSize, generalParagraphFontSize,
        generalTitleColor, generalSubTitleColor, generalParagraphColor
    } = data || {};
    const { imageShadow=true, spaceBetweenContent } = contentData || {};

    const pTop = contentData?.paddingTop ? contentData?.paddingTop : sectionPaddingTop ? sectionPaddingTop : null;
    const pBottom = contentData?.paddingBottom ? contentData?.paddingBottom : sectionPaddingBottom ? sectionPaddingBottom : null;

    const cardList = {
        'CardDesign_1': CardDesign_1,
        'CardDesign_2': CardDesign_2,
        'CardDesign_3': CardDesign_3,
        'CardDesign_4': CardDesign_4,
        'CardDesign_5': CardDesign_5
    };

    const TitleComponent = TitleList?.[themeDesign];
    const CardComponent = cardList[contentData['cardDesign']];
    return (
        <Box
            width="100%"
            style={{
                ...((contentData?.backgroundStyle === 'image' && contentData?.backgroundImage) ? 
                    {
                        backgroundSize: "cover",
                        backgroundImage: `url(${contentData?.backgroundImage})`,
                        backgroundRepeat: "no-repeat",
                    } 
                :
                (contentData?.backgroundStyle === 'gradient' && contentData?.backgroundColor) ? 
                    {
                        backgroundImage: contentData?.backgroundColor ? contentData?.backgroundColor : sectionBackgroundColor || 'transparent'
                    } 
                :
                (contentData?.backgroundStyle === 'solidColor' && contentData?.backgroundColor) ? 
                    {
                        backgroundColor: contentData?.backgroundColor || sectionBackgroundColor || 'transparent'
                    }
                : 
                {backgroundColor: contentData?.backgroundColor || sectionBackgroundColor || 'transparent'}
                )
            }}
            dir={isRTL === 'ar' ? 'rtl' : 'ltr'}
        >
        <SectionLayout paddingTop={pTop} paddingBottom={pBottom}>
            <Box className={classes.cardListDiv} style={{justifyContent:contentData?.spaceBetween ? contentData?.spaceBetween : 'space-between'}}>
                {React.Children.toArray(contentData?.cardList.map((v,i)=> {
                    if(v.title) {
                        return(
                            <CardComponent
                                
                                {...{...v, 
                                title: chatgptContent && Object.keys(chatgptContent).length ? chatgptContent?.['english']?.[`section${index}`]?.[i]?.['title'] : v.title,
                                arTitle: chatgptContent ? chatgptContent?.['arabic']?.[`section${index}`]?.[i]?.['title'] : v.arTitle,
                                description: chatgptContent && Object.keys(chatgptContent).length ? chatgptContent?.['english']?.[`section${index}`]?.[i]?.['description'] : v.description,
                                arDescription: chatgptContent && Object.keys(chatgptContent).length ? chatgptContent?.['arabic']?.[`section${index}`]?.[i]?.['description'] : v.arDescription,
                                addButton: v?.addButton === undefined ? true  : v?.addButton,
                                contentData,TitleComponent,index:i}}
                            />
                        )
                    }
                }))}
            </Box>
        </SectionLayout>
        </Box>
    );
};

function CardDesign_1(props) {
    const matches = useMediaQuery(theme.breakpoints.down('lg'));
    const mobileView = useMediaQuery(theme.breakpoints.down('md'));
    const { data } = useCompanyData();
    const { title, description, arTitle, arDescription, buttonTitle, arButtonTitle, image, path, externalLink, contentData, TitleComponent, index, addButton } = props || {};
    const { isRTL, themeDesign,  buttonFontSize, buttonWidth, buttonHeight, companyDomain,
        buttonRadiusGeneral, buttonColor, buttonFontColor
    } = data || {};
    const { pathname:url } = useLocation();
    const navigate = useNavigate();
    const { buttonBorder } = contentData || {};
    const classes = useStyles({shadow:contentData?.shadow,defaultShadow:'none'});
    const [, , themeFontFamily] = useRTL('',fontFamilyList?.[themeDesign]);

    const _buttonColor = contentData?.buttonColor ? contentData?.buttonColor : buttonColor ? buttonColor : '#2fccd5';
    const _buttonFontColor = contentData?.buttonFontColor ? contentData?.buttonFontColor : buttonFontColor ? buttonFontColor : '#ffffff';
    const _buttonFontSize = contentData?.buttonFontSize ? contentData?.buttonFontSize : buttonFontSize || '16';
    const _buttonWidth = contentData?.autoButtonSize ? 'fit-content' : mobileView ? 'fit-content' : contentData?.buttonWidth ? `${contentData?.buttonWidth}px` :
     'fit-content';
    const _buttonHeight = contentData?.autoButtonSize ? 'unset' : contentData?.buttonHeight ? `${contentData?.buttonHeight}px` :
    '70px';

    const btnRadius = contentData?.buttonRadius ? `${contentData?.buttonRadius}px` : buttonRadiusGeneral ? `${buttonRadiusGeneral}px` : '0px'; 


    // card
    const cardRadius = contentData?.cardRadius ? `${contentData?.cardRadius}px` : '0px'; 
    const cardBorder = contentData?.border || 'none'; 
    const titleFontSize = contentData?.titleFontSize ? contentData?.titleFontSize : '24';
    const descriptionFontSize = contentData?.descriptionFontSize ? contentData?.descriptionFontSize : '16';
    const titleFontColor = contentData?.titleFontColor ? contentData?.titleFontColor : '';
    const descFontColor = contentData?.textFontColor ? contentData?.textFontColor : '#a2a2a2';
    const buttonEvent = () => {
        if(path) {
            var _path = url?.split('/temp')[0];
            navigate(companyDomain ? `/temp/${path}` : `${_path}/temp/${path}`)
        };
        if(externalLink){
            navigate(externalLink,'_blank')
        }
    };

    const titleText = isRTL === 'ar' && arTitle ? arTitle : title;
    const descriptionText = isRTL === 'ar' && arDescription ? arDescription : description;
    const buttonText = isRTL === 'ar' && arButtonTitle ? arButtonTitle : buttonTitle || 'learn more';

    const imgStyle = { width: '100%', height: '100%', objectFit: !image ? 'contain' : 'cover' };
    const imgContStyle = {borderTopLeftRadius:cardRadius,borderTopRightRadius:cardRadius};
    const cardMargin = !mobileView ? isRTL === 'ar' ? {ml: 2} : {mr: 2} : {};
    const cardTransformStyle = {transform: `rotate(${index % 2 == 0 ? '-3' : '3'}deg)`};
    const cardPadding = contentData?.shadow || contentData?.cardBackgroundStyle ? {padding:'10px 10px 0px 10px'} : {};
    return (
        (<Box display="flex" flexDirection="column"
        maxWidth={{xs: '100%', sm: '100%', md: "calc(100% / 3.1)", lg: "calc(100% / 3.1)", xl: "420px" }}
        minWidth={{xs: '100%', sm: '100%', md: "calc(100% / 3.1)", lg: "calc(100% / 3.1)", xl: "420px" }}
        width={{xs: '100%', sm: '100%', md: "calc(100% / 3.1)", lg: "calc(100% / 3.1)", xl: "420px" }}
        style={{
            ...((contentData?.cardBackgroundStyle === 'image' && contentData?.cardBackgroundImage) ? 
                {
                    backgroundSize: "cover",
                    backgroundImage: `url(${contentData?.cardBackgroundImage})`,
                    backgroundRepeat: "no-repeat",
                } 
            : 
            (contentData?.cardBackgroundStyle === 'gradient' && contentData?.cardBackgroundColor) ? 
                {
                    backgroundImage: contentData?.cardBackgroundColor ? contentData?.cardBackgroundColor : '#ffffff',
                } 
            :
            (contentData?.cardBackgroundStyle === 'solidColor' && contentData?.cardBackgroundColor) ? 
                {
                    backgroundColor: contentData?.cardBackgroundColor || '#ffffff',
                } 
            : 
            {backgroundColor: 'transparent'}
            ),
            ...cardPadding
            }}
        border={cardBorder}
        borderRadius="undefinedpx"
        className={classes.cardShadow}
        mb={mobileView ? 3.5 : '10px'}
        {...(contentData?.spaceBetween === 'center' ? 
            {...cardMargin}
            : {}
        )}
        >
            <Box height="260px" bgcolor="#fff"
            boxShadow="0px 0px 30px 0px rgba(209, 209, 209, 1)"
            borderRadius="undefinedpx"
            style={{...cardTransformStyle,width:'calc(100% - 32px)',padding:'16px 16px 32px 16px'}}
            >
                <ImgLazyLoad>
                    <img
                    style={{...imgStyle}}
                    src={image || NoImage}
                    alt={title || 'feature'}
                    />
                </ImgLazyLoad>
            </Box>
            <Box
                py={5}
                px={['left','right']?.includes(contentData?.textAlign) ? 2 : '10px'}
                textAlign={isRTL === 'ar' && 
                (['left']?.includes(contentData?.textAlign)) ?
                'right' :
                contentData?.textAlign || 'center'}
                width={['left','right']?.includes(contentData?.textAlign) ? "calc(100% - 32px)" : "calc(100% - 20px)"}
            >
                <TitleComponent pb={2} noWrap pFontSize={titleFontSize} contentSection={true} {...(titleFontColor ? {color: titleFontColor} : {} )}>
                {titleText}
                </TitleComponent>
                <Box 
                    // style={{height:'80px',maxHeight:'80px', overflow:'hidden'}} 
                    color={descFontColor}>
                    <Typography
                        variant={descriptionFontSize && textVariant?.[descriptionFontSize] ? textVariant?.[descriptionFontSize] : textVariant?.['18']}
                        className={descriptionFontSize && textClasses?.[descriptionFontSize] ? textClasses?.[descriptionFontSize] : textClasses?.['18']}
                        style={{fontFamily:'inherit'}}
                    >
                    {descriptionText}
                    </Typography>
                </Box>

                {addButton ?
                <Box textAlign='center' pt={4}>
                    <CustomButton
                    style={{
                        backgroundColor: _buttonColor,
                        textTransform:'capitalize',
                        color: _buttonFontColor,
                        width: _buttonWidth,
                        minWidth: "160px",
                        height: _buttonHeight,
                        borderRadius: btnRadius,
                        fontFamily: 'inherit',
                        ...(buttonBorder ? {border: buttonBorder} : {}),
                        textTransform: 'uppercase',
                        fontWeight: 500,
                        boxShadow: '-15px 15px 9px -3px rgba(0,0,0,0.1)'
                    }}
                    onClick={buttonEvent}
                    className={textClasses?.[_buttonFontSize]}
                    >
                    {buttonText}
                    </CustomButton>
                </Box>
                : null}

          </Box>
        </Box>)
    );
}

function CardDesign_2(props) {
    const mobileView = useMediaQuery(theme.breakpoints.down('md'));
    const { data } = useCompanyData();
    const { title, description, arTitle, arDescription, buttonTitle, arButtonTitle, image, path, externalLink,contentData, TitleComponent,addButton } = props || {};
    const { isRTL, themeDesign, companyDomain, buttonFontColor, buttonColor, buttonRadiusGeneral, buttonFontSize } = data || {};
    const { pathname:url } = useLocation();
    const navigate = useNavigate();
    const classes = useStyles({shadow:contentData?.shadow,defaultShadow:'none'});
    const [, , themeFontFamily] = useRTL('',fontFamilyList?.[themeDesign]);
    const { buttonBorder } = contentData || {};
    const _buttonColor = contentData?.buttonColor ? contentData?.buttonColor : buttonColor ? buttonColor : '#fff';
    const _buttonFontColor = contentData?.buttonFontColor ? contentData?.buttonFontColor : buttonFontColor ? buttonFontColor : '#000';
    const _buttonFontSize = contentData?.buttonFontSize ? contentData?.buttonFontSize : buttonFontSize || '16';
    const _buttonWidth = contentData?.autoButtonSize ? 'fit-content' : mobileView ? 'fit-content' : contentData?.buttonWidth ? `${contentData?.buttonWidth}px` :
     'fit-content';
    const _buttonHeight = '50px';
    const btnRadius = contentData?.buttonRadius ? `${contentData?.buttonRadius}px` : buttonRadiusGeneral ? buttonRadiusGeneral : '8px'; 

    // card
    const cardRadius = contentData?.cardRadius ? `${contentData?.cardRadius}px` : '0px'; 
    const imgRadius = contentData?.cardRadius ? `${contentData?.cardRadius}px` : '4px'; 
    const cardBorder = contentData?.border || 'none'; 

    const titleFontSize = contentData?.titleFontSize ? contentData?.titleFontSize : '24';
    const descriptionFontSize = contentData?.descriptionFontSize ? contentData?.descriptionFontSize : '16';
    const titleFontColor = contentData?.titleFontColor ? contentData?.titleFontColor : '';
    const descFontColor = contentData?.textFontColor ? contentData?.textFontColor : '';

    const buttonEvent = () => {
        if(path) {
            var _path = url?.split('/temp')[0];
            navigate(companyDomain ? `/temp/${path}` : `${_path}/temp/${path}`)
        };
        if(externalLink){
            window.open(externalLink,'_blank')
        }
    };

    const titleText = isRTL === 'ar' && arTitle ? arTitle : title;
    const descriptionText = isRTL === 'ar' && arDescription ? arDescription : description;
    const buttonText = isRTL === 'ar' && arButtonTitle ? arButtonTitle : buttonTitle || 'learn more';
    const imgStyle = { width: '100%', height: '100%', objectFit: !image ? 'contain' : 'cover' };
    const imgContStyle = {borderBottomRightRadius:'4px',borderBottomLeftRadius:'4px'};
    const cardMargin = !mobileView ? isRTL === 'ar' ? {ml: 2} : {mr: 2} : {};
    return (
        (<Box display="flex" flexDirection="column"
        maxWidth={{xs: '100%', sm: '100%', md: "calc(100% / 3.1)", lg: "calc(100% / 3.1)", xl: "420px" }}
        minWidth={{xs: '100%', sm: '100%', md: "calc(100% / 3.1)", lg: "calc(100% / 3.1)", xl: "420px" }}
        width={{xs: '100%', sm: '100%', md: "calc(100% / 3.1)", lg: "calc(100% / 3.1)", xl: "420px" }}
        style={{
            ...((contentData?.cardBackgroundStyle === 'image' && contentData?.cardBackgroundImage) ? 
                {
                    backgroundSize: "cover",
                    backgroundImage: `url(${contentData?.cardBackgroundImage})`,
                    backgroundRepeat: "no-repeat",
                } 
            : 
            (contentData?.cardBackgroundStyle === 'gradient' && contentData?.cardBackgroundColor) ? 
                {
                    backgroundImage: contentData?.cardBackgroundColor ? contentData?.cardBackgroundColor : 'transparent'
                } 
            :
            (contentData?.cardBackgroundStyle === 'solidColor' && contentData?.cardBackgroundColor) ? 
                {
                    backgroundColor: contentData?.cardBackgroundColor || 'transparent'
                } 
            : 
            {backgroundColor: 'transparent'}
            )
            }}
        border={cardBorder}
        borderRadius={cardRadius || '0px'}
        className={classes.cardShadow}
        overflow="hidden"
        mb={mobileView ? 2 : '10px'}
        {...(contentData?.spaceBetween === 'center' ? 
            {...cardMargin}
            : {}
        )}
        >
            <Box height="260px" bgcolor="#fff"
            position="relative"
            style={cardRadius ? {...imgContStyle,width: '100%'} : {width: '100%'}}
            >
                <ImgLazyLoad>
                    <img
                    style={cardRadius ? {...imgContStyle,...imgStyle} : {...imgStyle}}
                    src={image || NoImage}
                    alt={title || 'feature'}
                    />
                </ImgLazyLoad>
                {addButton ?
                <CustomButton
                    style={{
                        backgroundColor: _buttonColor,
                        color: _buttonFontColor,
                        width: _buttonWidth,
                        minWidth: '130px',
                        height: _buttonHeight,
                        borderRadius: btnRadius,
                        ...(buttonBorder ? {border: buttonBorder} : {}),
                        fontFamily: 'inherit',
                        fontWeight: 600,
                        position:'absolute',
                        textTransform: 'capitalize',
                        bottom: '-25px',
                        boxShadow: '0px 10px 15px -3px rgba(0,0,0,0.1)',
                        ...(isRTL === 'ar' ? {left:'27px'} : {right: '27px'}),
                    }}
                    onClick={buttonEvent}
                    className={textClasses?.[_buttonFontSize]}
                    >
                    {buttonText}
                </CustomButton>
                : null}
            </Box>
            <Box
                style={{padding:'50px 10px 32px 10px'}}
                // px={['left','right']?.includes(contentData?.textAlign) ? 2 : ''}
                textAlign={isRTL === 'ar' && 
                (['left']?.includes(contentData?.textAlign) || !contentData?.textAlign) ?
                'right' :
                contentData?.textAlign || 'left'}
                width={"calc(100% - 20px)"}
            >
                <TitleComponent pb={2} noWrap pFontSize={titleFontSize} contentSection={true} {...(titleFontColor ? {color: titleFontColor} : {} )}>
                {titleText}
                </TitleComponent>
                <Box 
                    // style={{height:'80px',maxHeight:'80px', overflow:'hidden'}} 
                    color={descFontColor}>
                    <Typography
                        variant={descriptionFontSize && textVariant?.[descriptionFontSize] ? textVariant?.[descriptionFontSize] : textVariant?.['18']}
                        className={descriptionFontSize && textClasses?.[descriptionFontSize] ? textClasses?.[descriptionFontSize] : textClasses?.['18']}
                        style={{fontFamily:'inherit'}}
                    >
                    {descriptionText}
                    </Typography>
                </Box>
          </Box>
        </Box>)
    );
}

function CardDesign_3(props) {
    const mobileView = useMediaQuery(theme.breakpoints.down('md'));
    const { data } = useCompanyData();
    const { title, description, arTitle, arDescription, buttonTitle, arButtonTitle, image, path, externalLink, contentData, TitleComponent,addButton } = props || {};
    const { isRTL, themeDesign, companyDomain, buttonFontColor, buttonColor, buttonRadiusGeneral, buttonFontSize } = data || {};
    const { pathname:url } = useLocation();

    
    const navigate = useNavigate();
    const classes = useStyles({shadow:contentData?.shadow,defaultShadow:'none'});
    const [, , themeFontFamily] = useRTL('',fontFamilyList?.[themeDesign]);
    const { buttonBorder } = contentData || {};
    const _buttonColor = contentData?.buttonColor ? contentData?.buttonColor : buttonColor ? buttonColor : 'transparent';
    const _buttonFontColor = contentData?.buttonFontColor ? contentData?.buttonFontColor : buttonFontColor ? buttonFontColor : '#f17e76';
    const _buttonFontSize = contentData?.buttonFontSize ? contentData?.buttonFontSize : buttonFontSize || '16';
    const _buttonWidth = contentData?.autoButtonSize ? 'fit-content' : mobileView ? 'fit-content' : contentData?.buttonWidth ? `${contentData?.buttonWidth}px` :
     'fit-content';
    const _buttonHeight = contentData?.autoButtonSize ? 'unset' : contentData?.buttonHeight ? `${contentData?.buttonHeight}px` :
    'unset';
    const btnRadius = contentData?.buttonRadius ? `${contentData?.buttonRadius}px` : buttonRadiusGeneral ? `${buttonRadiusGeneral}px` : '0px'; 

    // card
    const cardRadius = contentData?.cardRadius ? `${contentData?.cardRadius}px` : '0px'; 
    const cardBorder = contentData?.border || 'none'; 

    const titleFontSize = contentData?.titleFontSize ? contentData?.titleFontSize : '24';
    const descriptionFontSize = contentData?.descriptionFontSize ? contentData?.descriptionFontSize : '16';
    const titleFontColor = contentData?.titleFontColor ? contentData?.titleFontColor : '';
    const descFontColor = contentData?.textFontColor ? contentData?.textFontColor : '';

    const buttonEvent = () => {
        if(path) {
            var _path = url?.split('/temp')[0];
            navigate(companyDomain ? `/temp/${path}` : `${_path}/temp/${path}`)
        };
        if(externalLink){
            window.open(externalLink,'_blank')
        }
    };

    const titleText = isRTL === 'ar' && arTitle ? arTitle : title;
    const descriptionText = isRTL === 'ar' && arDescription ? arDescription : description;
    const buttonText = isRTL === 'ar' && arButtonTitle ? arButtonTitle : buttonTitle || 'learn more';

    const imgStyle = { width: '100%', height: '100%', objectFit: !image ? 'contain' : 'cover' };
    // const imgContStyle = {borderTopLeftRadius:cardRadius,borderTopRightRadius:cardRadius};
    const cardMargin = !mobileView ? isRTL === 'ar' ? {ml: 2} : {mr: 2} : {};

    return (
        (<Box display="flex" flexDirection="column"
        maxWidth={{xs: '100%', sm: '100%', md: "calc(100% / 3.1)", lg: "calc(100% / 3.1)", xl: "420px" }}
        minWidth={{xs: '100%', sm: '100%', md: "calc(100% / 3.1)", lg: "calc(100% / 3.1)", xl: "420px" }}
        width={{xs: '100%', sm: '100%', md: "calc(100% / 3.1)", lg: "calc(100% / 3.1)", xl: "420px" }}
        style={{
            ...((contentData?.cardBackgroundStyle === 'image' && contentData?.cardBackgroundImage) ? 
                {
                    backgroundSize: "cover",
                    backgroundImage: `url(${contentData?.cardBackgroundImage})`,
                    backgroundRepeat: "no-repeat",
                } 
            : 
            (contentData?.cardBackgroundStyle === 'gradient' && contentData?.cardBackgroundColor) ? 
                {
                    backgroundImage: contentData?.cardBackgroundColor ? contentData?.cardBackgroundColor : '#ffffff'
                } 
            :
            (contentData?.cardBackgroundStyle === 'solidColor' && contentData?.cardBackgroundColor) ? 
                {
                    backgroundColor: contentData?.cardBackgroundColor || '#ffffff'
                } 
            : 
            {backgroundColor: 'transparent'}
            )
            }}
        border={cardBorder}
        borderRadius={cardRadius || '0px'}
        className={classes.cardShadow}
        overflow="hidden"
        mb={mobileView ? 2 : '10px'}
        {...(contentData?.spaceBetween === 'center' ? 
            {...cardMargin}
            : {}
        )}
        >
            <Box height="260px" bgcolor="#fff"
            style={cardRadius ? {width:'100%'} : {width:'100%'}}
            >
                <ImgLazyLoad>
                    <img
                    style={{...imgStyle}}
                    src={image || NoImage}
                    alt={title || 'feature'}
                    />
                </ImgLazyLoad>
            </Box>
            <Box
                py={4}
                px={['left','right']?.includes(contentData?.textAlign) ? 2 : '10px'}
                textAlign={isRTL === 'ar' && 
                (['left']?.includes(contentData?.textAlign)) ?
                'right' :
                contentData?.textAlign || 'center'}
                width={['left','right']?.includes(contentData?.textAlign) ? "calc(100% - 32px)" : "calc(100% - 20px)"}
            >
                <TitleComponent pb={2} noWrap pFontSize={titleFontSize} contentSection={true} {...(titleFontColor ? {color: titleFontColor} : {} )}>
                {titleText}
                </TitleComponent>
                <Box
                    // style={{height:'80px',maxHeight:'80px', overflow:'hidden'}} 
                    color={descFontColor}>
                    <Typography
                        variant={descriptionFontSize && textVariant?.[descriptionFontSize] ? textVariant?.[descriptionFontSize] : textVariant?.['18']}
                        className={descriptionFontSize && textClasses?.[descriptionFontSize] ? textClasses?.[descriptionFontSize] : textClasses?.['18']}
                        style={{fontFamily:'inherit'}}
                    >
                    {descriptionText}
                    </Typography>
                </Box>

                {addButton ?
                <Box textAlign='center' pt={2}>
                    <CustomButton
                    style={{
                        backgroundColor: _buttonColor,
                        textTransform:'capitalize',
                        color: _buttonFontColor,
                        width: _buttonWidth,
                        minWidth: "130px",
                        height: _buttonHeight,
                        borderRadius: btnRadius,
                        ...(buttonBorder ? {border: buttonBorder} : {}),
                        fontFamily: 'inherit',
                        textTransform: 'uppercase',
                        fontWeight: 600
                    }}
                    onClick={buttonEvent}
                    className={textClasses?.[_buttonFontSize]}
                    >
                    {buttonText}
                    </CustomButton>
                </Box>
                : null}

            </Box>
        </Box>)
    );
}

function CardDesign_4(props) {
    const mobileView = useMediaQuery(theme.breakpoints.down('md'));
    const { data } = useCompanyData();
    const { title, description, arTitle, arDescription, buttonTitle, arButtonTitle, image, externalLink, path, contentData, TitleComponent, index, addButton } = props || {};
    const { isRTL, themeDesign, companyDomain, buttonColor, buttonFontColor, buttonRadiusGeneral, buttonFontSize } = data || {};
    const { pathname:url } = useLocation();
    const navigate = useNavigate();
    const classes = useStyles({shadow:contentData?.shadow,defaultShadow:'0px 4px 15px -3px rgba(0,0,0,0.1), -2px -2px 15px -3px rgba(0,0,0,0.1)'});
    const [, , themeFontFamily] = useRTL('',fontFamilyList?.[themeDesign]);
    const { buttonBorder } = contentData || {};
    const _buttonColor = contentData?.buttonColor ? contentData?.buttonColor : buttonColor ? buttonColor : 'transparent';
    const _buttonFontColor = contentData?.buttonFontColor ? contentData?.buttonFontColor : buttonFontColor ? buttonFontColor : '#242f43';
    const _buttonFontSize = contentData?.buttonFontSize ? contentData?.buttonFontSize : buttonFontSize || '16';
    const _buttonWidth = contentData?.autoButtonSize ? 'fit-content' : mobileView ? 'fit-content' : contentData?.buttonWidth ? `${contentData?.buttonWidth}px` :
     'fit-content';
    const _buttonHeight = contentData?.autoButtonSize ? 'unset' : contentData?.buttonHeight ? `${contentData?.buttonHeight}px` :
    'unset';
    const btnRadius = contentData?.buttonRadius ? `${contentData?.buttonRadius}px` : buttonRadiusGeneral ? `${buttonRadiusGeneral}px` : '0px'; 

    // card
    const cardRadius = contentData?.cardRadius ? `${contentData?.cardRadius}px` : '12px'; 
    const cardBorder = contentData?.border || 'none'; 

    const titleFontSize = contentData?.titleFontSize ? contentData?.titleFontSize : '24';
    const descriptionFontSize = contentData?.descriptionFontSize ? contentData?.descriptionFontSize : '16';
    const titleFontColor = contentData?.titleFontColor ? contentData?.titleFontColor : '';
    const descFontColor = contentData?.textFontColor ? contentData?.textFontColor : '#b8babf';

    const buttonEvent = () => {
        if(path) {
            var _path = url?.split('/temp')[0];
            navigate(companyDomain ? `/temp/${path}` : `${_path}/temp/${path}`)
        };
        if(externalLink){
            window.open(externalLink,'_blank')
        }
    };

    const titleText = isRTL === 'ar' && arTitle ? arTitle : title;
    const descriptionText = isRTL === 'ar' && arDescription ? arDescription : description;
    const buttonText = isRTL === 'ar' && arButtonTitle ? arButtonTitle : buttonTitle || 'read more';

    const imgStyle = { width: '100%', height: '100%', objectFit: 'contain' };
    const cardMargin = !mobileView ? isRTL === 'ar' ? {ml: 2} : {mr: 2} : {};

    return (
        (<Box display="flex" flexDirection="column"
        maxWidth={{xs: '100%', sm: '100%', md: "calc(100% / 3.1)", lg: "calc(100% / 3.1)", xl: "420px" }}
        minWidth={{xs: '100%', sm: '100%', md: "calc(100% / 3.1)", lg: "calc(100% / 3.1)", xl: "420px" }}
        width={{xs: '100%', sm: '100%', md: "calc(100% / 3.1)", lg: "calc(100% / 3.1)", xl: "420px" }}
        style={{
            ...((contentData?.cardBackgroundStyle === 'image' && contentData?.cardBackgroundImage) ? 
                {
                    backgroundSize: "cover",
                    backgroundImage: `url(${contentData?.cardBackgroundImage})`,
                    backgroundRepeat: "no-repeat",
                } 
            : 
            (contentData?.cardBackgroundStyle === 'gradient' && contentData?.cardBackgroundColor) ? 
                {
                    backgroundImage: contentData?.cardBackgroundColor ? contentData?.cardBackgroundColor : '#ffffff',
                } 
            :
            (contentData?.cardBackgroundStyle === 'solidColor' && contentData?.cardBackgroundColor) ? 
                {
                    backgroundColor: contentData?.cardBackgroundColor || '#ffffff',
                } 
            : 
            {backgroundColor: '#ffffff'}
            ),
            }}
        border={cardBorder}
        borderRadius="undefinedpx"
        className={classes.cardShadow}
        mb={mobileView ? 3.5 : '10px'}
        {...(contentData?.spaceBetween === 'center' ? 
            {...cardMargin}
            : {}
        )}
        >
            <Box display="flex" flexDirection={"column"} px="50px" width="calc(100% - 100px)">
                <Box height="150px" bgcolor={contentData?.iconBackgroundColor || "#00346e"}
                width="115px"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                style={{borderBottomLeftRadius:'8px',borderBottomRightRadius:'8px'}}
                >
                    <Box width="70%" height="70%">
                        <ImgLazyLoad height="80%" width="80%">
                            <img
                            style={{...imgStyle}}
                            src={image || NoImage}
                            alt={title || 'feature'}
                            />
                        </ImgLazyLoad>
                    </Box>
                </Box>

                <Box
                    py={5}
                    px={"10px"}
                    // px={['left','right']?.includes(contentData?.textAlign) ? 2 : ''}
                    textAlign={isRTL === 'ar' && 
                    (['left']?.includes(contentData?.textAlign) || !contentData?.textAlign) ?
                    'right' :
                    contentData?.textAlign || 'left'}
                    width={"calc(100% - 20px)"}
                >
                    <TitleComponent pb={4} noWrap pFontSize={titleFontSize} contentSection={true} {...(titleFontColor ? {color: titleFontColor} : {} )}>
                    {titleText}
                    </TitleComponent>
                    <Box
                        // style={{height:'80px',maxHeight:'80px', overflow:'hidden'}} 
                        color={descFontColor}>
                        <Typography
                            variant={descriptionFontSize && textVariant?.[descriptionFontSize] ? textVariant?.[descriptionFontSize] : textVariant?.['18']}
                            className={descriptionFontSize && textClasses?.[descriptionFontSize] ? textClasses?.[descriptionFontSize] : textClasses?.['18']}
                            style={{fontFamily:'inherit'}}
                        >
                        {descriptionText}
                        </Typography>
                    </Box>

                    {addButton ?
                    <Box textAlign={isRTL === 'ar' && 
                        (['left']?.includes(contentData?.textAlign) || !contentData?.textAlign) ?
                        'right' : contentData?.textAlign || 'left'} 
                    pt={4}>
                        <CustomButton
                        style={{
                            backgroundColor: _buttonColor,
                            textTransform:'capitalize',
                            color: _buttonFontColor,
                            width: _buttonWidth,
                            minWidth: _buttonColor !== 'transparent' ? "160px" : "",
                            height: _buttonHeight,
                            borderRadius: btnRadius,
                            ...(buttonBorder ? {border: buttonBorder} : {}),
                            fontFamily: 'inherit',
                            fontWeight: 500,
                            textAlign: _buttonColor !== 'transparent' ? 'center' : 'left',
                            paddingLeft: _buttonColor !== 'transparent' ? 'inherit' : '0px',
                            paddingRight: _buttonColor !== 'transparent' ? 'inherit' : '0px',
                        }}
                        onClick={buttonEvent}
                        className={textClasses?.[_buttonFontSize]}
                        >
                        {buttonText}
                        </CustomButton>
                    </Box>
                    : null}
                </Box>
            </Box>
        </Box>)
    );
}

function CardDesign_5(props) {
    const mobileView = useMediaQuery(theme.breakpoints.down('md'));
    const { data } = useCompanyData();
    const { title, description, arTitle, arDescription, buttonTitle, arButtonTitle, image, path, externalLink, contentData, TitleComponent, index, addButton } = props || {};
    const { isRTL, themeDesign, companyDomain, buttonFontColor, buttonColor, buttonFontSize } = data || {};
    const { pathname:url } = useLocation();
    const navigate = useNavigate();
    const classes = useStyles({shadow:contentData?.shadow,defaultShadow:'-7px -3px 6px -3px rgba(0,0,0,0.1),7px -3px 6px -3px rgba(0,0,0,0.1);'});
    const [, , themeFontFamily] = useRTL('',fontFamilyList?.[themeDesign]);
    const _buttonColor = contentData?.buttonColor ? contentData?.buttonColor : buttonColor ? buttonColor : '';
    const _buttonFontColor = contentData?.buttonFontColor ? contentData?.buttonFontColor : buttonFontColor ? buttonFontColor : '#fff';
    const _buttonFontSize = contentData?.buttonFontSize ? contentData?.buttonFontSize : buttonFontSize || '16';
    const _buttonWidth = '100%';
    const _buttonHeight = mobileView ? '120px' :  contentData?.autoButtonSize ? '120px' : contentData?.buttonHeight ? `${contentData?.buttonHeight}px` :
    '120px';

    // card
    const cardRadius = contentData?.cardRadius ? `${contentData?.cardRadius}px` : '0px'; 
    const cardBorder = contentData?.border || 'none'; 

    const titleFontSize = contentData?.titleFontSize ? contentData?.titleFontSize : '24';
    const descriptionFontSize = contentData?.descriptionFontSize ? contentData?.descriptionFontSize : '16';
    const titleFontColor = contentData?.titleFontColor ? contentData?.titleFontColor : '';
    const descFontColor = contentData?.textFontColor ? contentData?.textFontColor : '#94999c';

    const buttonEvent = () => {
        if(path) {
            var _path = url?.split('/temp')[0];
            navigate(companyDomain ? `/temp/${path}` : `${_path}/temp/${path}`)
        };
        if(externalLink){
            window.open(externalLink,'_blank')
        }
    };

    const titleText = isRTL === 'ar' && arTitle ? arTitle : title;
    const descriptionText = isRTL === 'ar' && arDescription ? arDescription : description;
    const buttonText = isRTL === 'ar' && arButtonTitle ? arButtonTitle : buttonTitle || 'learn more';

    const imgStyle = { width: '100%', height: '100%', objectFit: 'contain' };
    const cardMargin = !mobileView ? isRTL === 'ar' ? {ml: 2} : {mr: 2} : {};
    return (
        (<Box display="flex" flexDirection="column"
        maxWidth={{xs: '100%', sm: '100%', md: "calc(100% / 3.1)", lg: "calc(100% / 3.1)", xl: "420px" }}
        minWidth={{xs: '100%', sm: '100%', md: "calc(100% / 3.1)", lg: "calc(100% / 3.1)", xl: "420px" }}
        width={{xs: '100%', sm: '100%', md: "calc(100% / 3.1)", lg: "calc(100% / 3.1)", xl: "420px" }}
        style={{
            ...((contentData?.cardBackgroundStyle === 'image' && contentData?.cardBackgroundImage) ? 
                {
                    backgroundSize: "cover",
                    backgroundImage: `url(${contentData?.cardBackgroundImage})`,
                    backgroundRepeat: "no-repeat",
                } 
            : 
            (contentData?.cardBackgroundStyle === 'gradient' && contentData?.cardBackgroundColor) ? 
                {
                    backgroundImage: contentData?.cardBackgroundColor ? contentData?.cardBackgroundColor : '#ffffff',
                } 
            :
            (contentData?.cardBackgroundStyle === 'solidColor' && contentData?.cardBackgroundColor) ? 
                {
                    backgroundColor: contentData?.cardBackgroundColor || '#ffffff',
                } 
            : 
            {backgroundColor: '#ffffff'}
            ),
            }}
        border={cardBorder}
        borderRadius="undefinedpx"
        className={classes.cardShadow}
        mb={mobileView ? 3.5 : '10px'}
        {...(contentData?.spaceBetween === 'center' ? 
            {...cardMargin}
            : {}
        )}
        mt="75px"
        position="relative"
        >
            {/* icon */}
            <Box
                height="150px"
                width="150px"
                bgcolor={contentData?.iconBackgroundColor || "#f6e801"}
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                position="absolute"
                margin="auto"
                borderRadius="50%"
                style={{transform:"translateY(-50%)",left:0,right:0,top:0}}
            >
                <Box width="50%" height="50%">
                    <ImgLazyLoad>
                        <img
                        style={{...imgStyle}}
                        src={image || NoImage}
                        alt={title || 'feature'}
                        />
                    </ImgLazyLoad>
                </Box>
            </Box>
            <Box display="flex" flexDirection="column" px="50px" pt="70px" width="calc(100% - 100px)">
                <Box
                    py={5}
                    textAlign={isRTL === 'ar' && 
                    (['left']?.includes(contentData?.textAlign)) ?
                    'right' :
                    contentData?.textAlign || 'center'}
                    width={"100%"}
                >
                    <TitleComponent pb={4} noWrap pFontSize={titleFontSize} contentSection={true} {...(titleFontColor ? {color: titleFontColor} : {} )}>
                    {titleText}
                    </TitleComponent>
                    <Box
                        // style={{height:'80px',maxHeight:'80px', overflow:'hidden'}}
                        color={descFontColor}>
                        <Typography
                            variant={descriptionFontSize && textVariant?.[descriptionFontSize] ? textVariant?.[descriptionFontSize] : textVariant?.['18']}
                            className={descriptionFontSize && textClasses?.[descriptionFontSize] ? textClasses?.[descriptionFontSize] : textClasses?.['18']}
                            style={{fontFamily:'inherit'}}
                        >
                        {descriptionText}
                        </Typography>
                    </Box>
                </Box>
            </Box>
            {addButton ?
            <Box
                pt={4}
            >
                <CustomButton
                style={{
                    backgroundColor: _buttonColor,
                    textTransform:'uppercase',
                    color: _buttonFontColor,
                    width: _buttonWidth,
                    height: _buttonHeight,
                    // borderRadius: btnRadius,
                    fontFamily: 'inherit',
                    fontWeight: 600,
                    letterSpacing:'2px'
                    // textAlign: _buttonColor !== 'transparent' ? 'center' : 'left',
                    // paddingLeft: _buttonColor !== 'transparent' ? 'inherit' : '0px',
                    // paddingRight: _buttonColor !== 'transparent' ? 'inherit' : '0px',
                }}
                {...(!_buttonColor ? {className:`${classes.card5BtnCl} ${textClasses?.[_buttonFontSize]}`} : {className: textClasses?.[_buttonFontSize]} )}
                onClick={buttonEvent}
                >
                {buttonText}
                </CustomButton>
            </Box>
            : null}
        </Box>)
    );
}

const CustomButton = ({ children, ...props }) => {
    return (
      <Button size="large" variant="contained" color="primary" {...props}>
        {children}
      </Button>
    );
};

export default Features;